export default "__VITE_ASSET__27b90cef__"